module.exports = __webpack_public_path__ + "img/Schreiber Josef.jpg";